import { html, LitElement } from 'lit';

class Erroricon extends LitElement {
  render() {
    return html`<svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_30_6)">
        <path
          d="M36 0C39.3047 0 42.4922 0.421875 45.5625 1.26562C48.6328 2.10938 51.4922 3.32813 54.1406 4.92188C56.7891 6.51562 59.2148 8.39063 61.418 10.5469C63.6211 12.7031 65.5078 15.1289 67.0781 17.8242C68.6484 20.5195 69.8555 23.3906 70.6992 26.4375C71.543 29.4844 71.9766 32.6719 72 36C72 39.3047 71.5781 42.4922 70.7344 45.5625C69.8906 48.6328 68.6719 51.4922 67.0781 54.1406C65.4844 56.7891 63.6094 59.2148 61.4531 61.418C59.2969 63.6211 56.8711 65.5078 54.1758 67.0781C51.4805 68.6484 48.6094 69.8555 45.5625 70.6992C42.5156 71.543 39.3281 71.9766 36 72C32.6953 72 29.5078 71.5781 26.4375 70.7344C23.3672 69.8906 20.5078 68.6719 17.8594 67.0781C15.2109 65.4844 12.7852 63.6094 10.582 61.4531C8.37891 59.2969 6.49219 56.8711 4.92188 54.1758C3.35156 51.4805 2.14453 48.6094 1.30078 45.5625C0.457031 42.5156 0.0234375 39.3281 0 36C0 32.6953 0.421875 29.5078 1.26562 26.4375C2.10938 23.3672 3.32813 20.5078 4.92188 17.8594C6.51562 15.2109 8.39063 12.7852 10.5469 10.582C12.7031 8.37891 15.1289 6.49219 17.8242 4.92188C20.5195 3.35156 23.3906 2.14453 26.4375 1.30078C29.4844 0.457031 32.6719 0.0234375 36 0ZM39.9727 36L51.9961 23.9766L48.0234 20.0039L36 32.0273L23.9766 20.0039L20.0039 23.9766L32.0273 36L20.0039 48.0234L23.9766 51.9961L36 39.9727L48.0234 51.9961L51.9961 48.0234L39.9727 36Z"
          fill="#FF0000"
        />
      </g>
      <defs>
        <clipPath id="clip0_30_6">
          <rect width="72" height="72" fill="white" />
        </clipPath>
      </defs>
    </svg> `;
  }
}

customElements.define('error-icon', Erroricon);
